








import { PropertyData } from '@beyondview/firebase-client-8';
import Vue, { PropType } from 'vue';
import { MetaInfo } from 'vue-meta';

import PropertyProfileForm from '@/components/forms/PropertyProfileForm.vue';

export default Vue.extend( {
	components: {
		PropertyProfileForm
	},
	props: {
		property: {
			type: Object as PropType<PropertyData>,
			required: true
		}
	},
	head(): MetaInfo {
		return {
			title: `${this.$t( 'views.property.details.details' )}`
		};
	}
} );
